import { withPrefix } from "gatsby"

export const createObjectForInternalLinkingBlock = object => {
  // redirection hotfix
  let url = object.url + "/"

  return {
    href: withPrefix(url),
    label: `Hotels in ${object.name}`,
  }
}

export const createLocationCarouselData = object => {
  if (typeof object === "undefined") {
    return {
      href: withPrefix("/"),
      label: "Error",
      imageUrl: "",
    }
  }

  // redirection hotfix
  let url = object.url + "/"

  return {
    href: withPrefix(url),
    label: object.name,
    imageUrl: object.imageUrl,
  }
}

export const addForwardslashToLinks = link => {
  if (link.charAt(link.length - 1) === "/") {
    return link
  } else {
    return link + "/"
  }
}

export const getGtmUserType = () => {
  let gtmUserType = "NewUser"

  if (
    typeof localStorage !== "undefined" &&
    localStorage.getItem("recentSearches")
  ) {
    gtmUserType = "ReturnNonPersonalizedUser"
  }

  return gtmUserType
}

export const fireGtmEvent = obj => {
  if (typeof window !== "undefined") {
    window.gtmDataLayer = window.gtmDataLayer || []
    window.gtmDataLayer.push(obj)
  }
}

export const shuffleArray = array => {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex)
    currentIndex -= 1

    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }

  return array
}
